import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@application/config';
import { Observable } from 'rxjs';
import {
  SchoolMessageSettings,
  SchoolMessageSettingsRequest,
} from '../entities/school-message-settings.model';

/**
 * `/MessageSettings` (SchoolService) — per-tenant access-denial messages shown
 * on the access screen. `GET` returns the tenant's messages (creating the row
 * with service defaults on first read); `PUT` patches only the provided fields
 * and echoes the full updated record.
 */
@Injectable({ providedIn: 'root' })
export class SchoolMessageSettingsService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(APP_CONFIG).apiUrl.school_service;

  public get(): Observable<SchoolMessageSettings> {
    return this.http.get<SchoolMessageSettings>(`${this.baseUrl}/MessageSettings`, {
      withCredentials: true,
    });
  }

  public update(body: SchoolMessageSettingsRequest): Observable<SchoolMessageSettings> {
    return this.http.put<SchoolMessageSettings>(`${this.baseUrl}/MessageSettings`, body, {
      withCredentials: true,
    });
  }
}
